import { Question } from '.';

export class Test {
  id: number;
  title: string;
  type: string;
  description: string;
  questions: Question[] = [];
  lastModified: Date;
  minHours: number;

  constructor(json: any) {
    if (json) {
      this.updateTest(json);
      if (json.id) this.id = json.id;
      if (json.updated_at) this.lastModified = new Date(json.updated_at);
    }
  }

  get typeString() {
    return this.type === 'test' ? 'Test' : 'Practice Test';
  }

  toJson() {
    let json = {
      title: this.title,
      type: this.type,
      description: this.description,
      last_modified: this.lastModified.toJSON(),
      questions: this.questions.map(question => question.toJson())
    };
    if (this.minHours) json['minimum_hours'] = this.minHours;
    if (this.id) json['id'] = this.id;
    return json;
  }

  updateTest(json: any) {
    if (json.title) this.title = json.title;
    if (json.type) this.type = json.type;
    if (json.description) this.description = json.description;
    if (json.minimum_hours) this.minHours = json.minimum_hours;
    if (json.questions) this.updateTestQuestionsWithJson(json.questions);
    this.lastModified = new Date();
  }

  updateTestQuestionsWithJson(questionsJson: any[]) {
    this.questions = questionsJson.map(questionJson => {
      return new Question(questionJson);
    })
  }

  updateTestQuestions(questions: Question[]) {
    this.questions = questions;
  }
}


// WEBPACK FOOTER //
// /app/src/app/shared/services/app/content/models/test.model.ts